import { createContext } from "react";
export const GroupContext = createContext({});
